exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fly-header[data-v-2d5af6a2]{position:absolute;left:0;top:5px}", ""]);

// exports
